<!-- Enhanced Loader with Progress Flow -->
<div *ngIf="isLoader && pdfGenerationInProgress" class="pdf-loader-overlay">
    <div class="pdf-loader-content">
        <div class="spinner"></div>
        <div class="loader-text">Starting PDF generation...</div>
        <div class="loader-percent">0%</div>
        <div class="progress-bar-container">
            <div class="progress-bar-fill" style="width: 0%"></div>
        </div>
        <div class="loader-steps">
            <div class="step" id="step-capture">📋 Capture Card</div>
            <div class="step" id="step-resources">📥 Resources</div>
            <div class="step" id="step-process">🔄 Process</div>
            <div class="step" id="step-pdf">📄 Generate PDF</div>
        </div>
    </div>
</div>

<app-web-loader *ngIf="isLoader && !pdfGenerationInProgress"></app-web-loader>

<div id="main-venture-div">
    <div class="venture-inner-div">
        <div class="venture-list-view" *ngIf="isVentureView">

            <div *ngIf="IsAddVenture" class="row mb-2"> <!-- Add margin-bottom -->
                <div class="col-12 text-end">
                    <button type="button" (click)="ShowVentureAdd()" class="btn btn-sm btn-success"
                        style="float: right;">
                        <i class="fas fa-plus-circle"></i> Add Project / Venture
                    </button>
                </div>
            </div>

            <div class="row ventureListDiv">

                <div class="container-fluid no-margin">
                    <div class="row">
                        <div class="col-12">

                            <article *ngFor="let project of ventureList;" class="box_div card car-details"
                                [id]="'venture-info-' + project.ProjectID">
                                <div class="row">
                                    <div class="col-sm-9 pad10L pad10R">
                                        <div class="box_br">
                                            <div class="row">
                                                <div class="col-md-7 title_div">
                                                    <div> <img [src]='project.Project_Logo'
                                                            style="width:auto; height: 80px;" /></div>
                                                    <!-- Add after the Property_Title in the title_div section -->
                                                    <div class="pad10L">
                                                        <h6 class="mrg0B">{{ project?.Developer_Name }}</h6>
                                                        <strong class="Property_Title">{{ project.ProjectOrVentureName
                                                            }}</strong>

                                                        <!-- Category Badge -->
                                                        <span class="badge ml-2" [ngClass]="{
        'badge-success': project.Property_Type == 1,
        'badge-primary': project.Property_Type == 2,
        'badge-warning': project.Property_Type == 3
    }">
                                                            <ng-container *ngIf="project.Property_Type == 1">🏠
                                                                Residential</ng-container>
                                                            <ng-container *ngIf="project.Property_Type == 2">🏢
                                                                Commercial</ng-container>
                                                            <ng-container *ngIf="project.Property_Type == 3">📍 Land /
                                                                Plot</ng-container>
                                                        </span>

                                                        <div class="addressParam">
                                                            <img src='assets/images/icons/Location.png'
                                                                style="width:20px; height: 22px;" />
                                                            {{ project?.AreaName }}
                                                            <span class="text-muted ml-2">📍 {{ project.Latitude }}, {{
                                                                project.Longitude }}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-5 text-right">
                                                    <div class="rating_sec">
                                                        <div class="report">
                                                            <!-- Download Button -->
                                                            <button title="Download Venture"
                                                                (click)="downloadVenture(project)">
                                                                <img src='assets/images/icons/apps.png'>
                                                            </button>

                                                            <!-- Share Button -->
                                                            <button title="Share Venture"
                                                                (click)="shareVenture(project)">
                                                                <img src='assets/images/icons/share.png'>
                                                            </button>

                                                            <!-- Like Button -->
                                                            <button title="Like Venture" (click)="likeVenture(project)">
                                                                <img src='assets/images/icons/favorite_icon.png'>
                                                            </button>

                                                            <!-- Edit Button (only for logged-in user's own ventures) -->
                                                            <button (click)="showEditPage(project)"
                                                                *ngIf="IsAddVenture && project?.Status != 1"
                                                                title="Edit Venture">
                                                                <img src='assets/images/edit.png'>
                                                            </button>
                                                        </div>

                                                        <div class="rating">
                                                            <div class="align-left price_txt"> {{ project.PricingDetails
                                                                }}</div>
                                                            <ul class="rating mrg0T">
                                                                <li><i class="fas fa-star text-warning"></i></li>
                                                                <li><i class="fas fa-star text-warning"></i></li>
                                                                <li><i class="fas fa-star text-warning"></i></li>
                                                                <li><i class="fas fa-star text-warning"></i></li>
                                                                <li><i class="fas fa-star text-grey"></i></li>
                                                                <li>{{ project?.AvgRating == '' ? 0 : project?.AvgRating
                                                                    }}/5</li>
                                                            </ul>
                                                            <div class="ratings_txt">{{ project?.NumOfRatings == '' ? 0
                                                                : project?.NumOfRatings }} ratings</div>
                                                            <div class="clearfix"></div>
                                                            <!-- <div class="rating_hd"
                                                                (click)="doRateYourSelf(project?.ProjectID)">
                                                                Write Review
                                                                <img src='assets/icons/leave_review.png' />
                                                            </div> -->
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="clearfix mrg10B"></div>
                                            <div class="row">
                                                <div class="col-xl-6 mrg10B">
                                                    <div *ngIf="project?.ProjectResources_JSON.length > 0"
                                                        class="property_images">

                                                        <div id="carouselExampleControls{{ project.ProjectID }}"
                                                            class="carousel slide" data-ride="carousel"
                                                            data-interval="false">
                                                            <div class="carousel-inner">
                                                                <div class="carousel-item thumbnail-container"
                                                                    [ngClass]="i === 0 ? 'active' : ''"
                                                                    *ngFor="let media of project.ProjectResources_JSON; let i = index">

                                                                    <ng-container
                                                                        *ngIf="!isVideo(media.FileName); else videoTemplate">
                                                                        <img class="d-block w-100 thumbnail"
                                                                            [src]="media.FileName"
                                                                            onerror="this.src='assets/images/no-image.png';"
                                                                            alt="Media slide"
                                                                            (click)="ViewImages(project.ProjectResources_JSON)" />
                                                                    </ng-container>
                                                                    <ng-template #videoTemplate>
                                                                        <div class="video-container"
                                                                            *ngIf="isVideoAvailable(media.FileName); else comingSoonTemplate">
                                                                            <video class="d-block w-100 thumbnail"
                                                                                #videoElement>
                                                                                <source [src]="media.FileName"
                                                                                    type="video/mp4">
                                                                                Your browser does not support the video
                                                                                tag.
                                                                            </video>
                                                                            <div class="video_btn">
                                                                                <button class="play-button"
                                                                                    (click)="playVideo(videoElement, project.ProjectID)">Play</button>
                                                                                <button class="stop-button"
                                                                                    (click)="stopVideo(videoElement, project.ProjectID)">Stop</button>
                                                                                <button class="full-screen-button"
                                                                                    (click)="toggleFullScreen(videoElement)">Full
                                                                                    Screen</button>
                                                                            </div>
                                                                        </div>
                                                                        <ng-template #comingSoonTemplate>
                                                                            <div class="coming-soon">
                                                                                <p>Coming Soon</p>
                                                                            </div>
                                                                        </ng-template>
                                                                    </ng-template>
                                                                </div>
                                                            </div>
                                                            <a class="carousel-control-prev"
                                                                href="#carouselExampleControls{{ project.ProjectID }}"
                                                                role="button" data-slide="prev">
                                                                <span class="carousel-control-prev-icon"
                                                                    aria-hidden="true"></span>
                                                                <span class="sr-only">Previous</span>
                                                            </a>
                                                            <a class="carousel-control-next"
                                                                href="#carouselExampleControls{{ project.ProjectID }}"
                                                                role="button" data-slide="next">
                                                                <span class="carousel-control-next-icon"
                                                                    aria-hidden="true"></span>
                                                                <span class="sr-only">Next</span>
                                                            </a>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-xl-6">
                                                    <div class="container-fluid">
                                                        <div class="row property_details">
                                                            <div class="col-lg-6 col-12">
                                                                <ul>
                                                                    <li>
                                                                        <div> <img
                                                                                src='assets/images/ventures/area_icon.png'>
                                                                        </div>
                                                                        <div><span>Area Name</span>
                                                                            <div> {{ project.AreaName }} </div>
                                                                        </div>
                                                                    </li>
                                                                    <!-- Only show Blocks for Non-Land -->
                                                                    <li *ngIf="project.Property_Type != 3">
                                                                        <div> <img
                                                                                src='assets/images/ventures/blocks_icon.png'>
                                                                        </div>
                                                                        <div><span>Blocks</span>
                                                                            <div> {{ project.Blocks }} </div>
                                                                        </div>
                                                                    </li>
                                                                    <!-- Only show Floors for Non-Land -->
                                                                    <li *ngIf="project.Property_Type != 3">
                                                                        <div> <img
                                                                                src='assets/images/ventures/stairs_icon.png'>
                                                                        </div>
                                                                        <div><span>Floors</span>
                                                                            <div> {{ project.NumberOfFloors }} </div>
                                                                        </div>
                                                                    </li>
                                                                    <!-- Show appropriate label for Units/Plots -->
                                                                    <li>
                                                                        <div> <img
                                                                                src='assets/images/ventures/draw _icon.png'>
                                                                        </div>
                                                                        <div>
                                                                            <span>
                                                                                <ng-container
                                                                                    *ngIf="project.Property_Type == 3">Total
                                                                                    Plots</ng-container>
                                                                                <ng-container
                                                                                    *ngIf="project.Property_Type != 3">Units
                                                                                    / Plots</ng-container>
                                                                            </span>
                                                                            <div> {{ project.NumberOfUnitsOrPlots }}
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <!-- Show appropriate label for Types -->
                                                                    <li>
                                                                        <div> <img
                                                                                src='assets/images/ventures/bedroom_icon.png'>
                                                                        </div>
                                                                        <div>
                                                                            <span>
                                                                                <ng-container
                                                                                    *ngIf="project.Property_Type == 3">Plot
                                                                                    Sizes</ng-container>
                                                                                <ng-container
                                                                                    *ngIf="project.Property_Type == 2">Commercial
                                                                                    Types</ng-container>
                                                                                <ng-container
                                                                                    *ngIf="project.Property_Type == 1">Types
                                                                                    Of Units</ng-container>
                                                                            </span>
                                                                            <div> {{ project.TypesOfUnits }} </div>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div class="col-lg-6 col-12">
                                                                <ul>
                                                                    <li>
                                                                        <div> <img
                                                                                src='assets/images/ventures/developer.png'>
                                                                        </div>
                                                                        <div><span>Developers</span>
                                                                            <div> {{ project.Developer_Name }} </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div> <img
                                                                                src='assets/images/ventures/legal_approvals_icon.png'>
                                                                        </div>
                                                                        <div><span>Legal Approvals</span>
                                                                            <div> {{ project.LegalApprovals }} </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div> <img
                                                                                src='assets/images/ventures/project_status_icon.png'>
                                                                        </div>
                                                                        <div><span>Project Status</span>
                                                                            <div> {{ project.ProjectStatus }} </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div> <img
                                                                                src='assets/images/ventures/launch_date_icon.png'>
                                                                        </div>
                                                                        <div><span>Launch Date</span>
                                                                            <div> {{ project.LaunchDate }} </div>
                                                                        </div>
                                                                    </li>
                                                                    <li>
                                                                        <div> <img
                                                                                src='assets/images/ventures/completion_date_icon.png'>
                                                                        </div>
                                                                        <div><span>Completion Date</span>
                                                                            <div> {{ project.CompletionDate }} </div>
                                                                        </div>
                                                                    </li>

                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mrg15T">
                                            <div class="col-sm-12">
                                                <div class="box_br">
                                                    <div class="title_txt">Amenities</div>
                                                    <div class="leftli amenities">
                                                        <ul>
                                                            <li *ngFor="let aminity of project.Aminity_JSON"><img
                                                                    [src]='aminity.icon' />
                                                                <div>{{ aminity.name }}</div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <!-- {{ project.AREAS_JSON }}-->
                                            </div>
                                            <div class="col-sm-12 pad15T">
                                                <div class="box_br">
                                                    <div class="title_txt">Description</div>
                                                    <p [innerHtml]="project.Overview" class="para"></p>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 pad15T">
                                                <div class="box_br">
                                                    <div class="title_txt">Unlock Every Detail of Your Venture</div>
                                                    <div>Explore in-depth Project Plans, Unit Layouts, and Floor Designs
                                                    </div>
                                                    <div class="row mrg10T">
                                                        <div *ngIf="project?.ProjectVenture_Plan"
                                                            class="col-sm-4 align-center">
                                                            <strong> Master Plan</strong>
                                                            <div class="plan_div">
                                                                <img [src]="project?.ProjectVenture_Plan?.FileName"
                                                                    class="plan_img" />
                                                            </div>
                                                        </div>
                                                        <div *ngFor="let unitsPlan of project.UnitResources_Json"
                                                            class="col-sm-4 align-center">
                                                            <strong> {{ unitsPlan?.Label }}</strong>
                                                            <div class="plan_div">
                                                                <img [src]="unitsPlan?.FileName" class="plan_img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="col-sm-3 pad10L pad10R">
                                        <div class="box_br" align="center">
                                            <div class="title_txt">Project location</div>

                                            <!-- In the right side map section -->
                                            <ng-container *ngIf="!InitVentureViewMap(project); else mapViewTemplate">
                                                <h6>Google Map View Not Available</h6>
                                            </ng-container>
                                            <ng-template #mapViewTemplate>
                                                <div class="mapViewWrapper"
                                                    style="width: 100%; height: 250px; position: relative; cursor: pointer;">
                                                    <div class="innerMapView" id="ventureViewmap{{project.ProjectID}}"
                                                        style="width: 100%; height: 250px;"
                                                        (click)="openFullMapView(project)">
                                                        <h6 class="mapLoadingText">Loading Map...</h6>
                                                    </div>
                                                    <div class="map-expand-hint"
                                                        style="position: absolute; bottom: 5px; right: 5px; background: rgba(0,0,0,0.6); color: white; padding: 2px 8px; border-radius: 4px; font-size: 11px;">
                                                        <i class="fas fa-expand"></i> Click to expand
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <div class="title_txt">Find near by</div>

                                        </div>
                                        <div class="box_br mrg15T" align="center">
                                            <div class="title_txt">Live Street View</div>
                                            <div class="map_div">

                                                <ng-container
                                                    *ngIf="!InitVentureViewMap(project); else streetViewTemplate">
                                                    <h6>Live Street View Not Available</h6>
                                                </ng-container>
                                                <ng-template #streetViewTemplate>
                                                    <div class="mapViewWrapper"
                                                        style="width: 100%; height: 250px; position: relative;">
                                                        <div class="innerMapView" id="street-view{{project.ProjectID}}"
                                                            style="width: 100%; height: 250px;">
                                                            <h6 class="mapLoadingText">Loading Street View...</h6>
                                                        </div>
                                                    </div>
                                                </ng-template>

                                            </div>
                                        </div>
                                        <div class="box_br mrg15T" align="center">
                                            <div class="title_txt">Project Walkthrough</div>
                                            <div class="map_div">
                                                <!-- Check if WalkthroughVideo exists in resources -->
                                                <ng-container
                                                    *ngIf="getWalkthroughVideo(project) as walkthroughVideo; else noWalkthrough">
                                                    <!-- If it's a video file -->
                                                    <!-- Update the video template -->
                                                    <video *ngIf="isVideo(walkthroughVideo.FileName)" class="video_img"
                                                        [src]="walkthroughVideo.FileName"
                                                        style="width: 100%; max-height: 200px; cursor: pointer;"
                                                        (click)="viewUploadedVideo(walkthroughVideo.FileName)">
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <!-- If it's a YouTube URL -->
                                                    <iframe
                                                        *ngIf="!isVideo(walkthroughVideo.FileName) && walkthroughVideo.FileName.includes('youtube')"
                                                        [src]="getSafeUrl(walkthroughVideo.FileName)" frameborder="0"
                                                        allowfullscreen style="width: 100%; height: 200px;">
                                                    </iframe>
                                                    <!-- If it's an image -->
                                                    <img *ngIf="!isVideo(walkthroughVideo.FileName) && !walkthroughVideo.FileName.includes('youtube')"
                                                        [src]="walkthroughVideo.FileName" class="video_img"
                                                        style="cursor: pointer;"
                                                        (click)="ViewImages([walkthroughVideo])" />
                                                </ng-container>

                                                <!-- Default template when no walkthrough video exists -->
                                                <ng-template #noWalkthrough>
                                                    <img src='assets/images/ventures/project_walkthrough_image.png'
                                                        class="video_img" style="opacity: 0.6;" />
                                                    <p class="text-muted text-center mt-2" style="font-size: 12px;">
                                                        <i class="fas fa-info-circle"></i> No walkthrough video uploaded
                                                    </p>
                                                </ng-template>
                                            </div>
                                        </div>

                                        <!-- Update the social media icons section -->
                                        <div class="box_br mrg15T" align="center">
                                            <div align="center">
                                                <!-- YouTube -->
                                                <img *ngIf="project?.YouTubeUrl && project?.YouTubeUrl !== ''"
                                                    (click)="ViewMedia(project?.YouTubeUrl, 'youtube')"
                                                    src='assets/images/ventures/youtube_icon.png'
                                                    style="cursor: pointer;" />

                                                <!-- Facebook -->
                                                <img *ngIf="project?.FacebookUrl && project?.FacebookUrl !== ''"
                                                    (click)="ViewMedia(project?.FacebookUrl, 'facebook')"
                                                    src='assets/images/ventures/facebook_icon.png'
                                                    style="cursor: pointer;" />

                                                <!-- WhatsApp -->
                                                <img *ngIf="project?.Whatsapp && project?.Whatsapp !== ''"
                                                    (click)="ViewMedia(project?.Whatsapp, 'whatsapp')"
                                                    src='assets/images/ventures/whatsapp_icon.png'
                                                    style="cursor: pointer;" />

                                                <!-- Instagram -->
                                                <img *ngIf="project?.InstagramUrl && project?.InstagramUrl !== ''"
                                                    (click)="ViewMedia(project?.InstagramUrl, 'instagram')"
                                                    src='assets/images/ventures/tw_icon.png' style="cursor: pointer;" />

                                                <!-- Telegram -->
                                                <img *ngIf="project?.Telegram && project?.Telegram !== '' && project.Property_Type == 2"
                                                    (click)="ViewMedia(project?.Telegram, 'telegram')"
                                                    src='assets/images/ventures/telegram_icon.png'
                                                    style="cursor: pointer;" />
                                            </div>
                                            <hr>
                                            <div>
                                                <img (click)="ViewVentureBroucher(project?.Project_Brochure)"
                                                    src='assets/images/ventures/brochure_download_icon1.png'
                                                    style="cursor: pointer;" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- TABS FOR ANALYSIS SECTIONS -->
                                <div class="analysis-tabs-container">
                                    <!-- Tab Headers -->
                                    <ul class="nav nav-tabs analysis-tabs" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" [id]="'nearby-tab-' + project.ProjectID" data-toggle="tab"
                                                [attr.data-target]="'#nearby-content-' + project.ProjectID" type="button" role="tab"
                                                [attr.aria-controls]="'nearby-content-' + project.ProjectID" aria-selected="true">
                                                <i class="fas fa-store-alt tab-icon" aria-hidden="true"></i>
                                                <span class="tab-label">Nearby Places</span>
                                            </button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" [id]="'market-tab-' + project.ProjectID" data-toggle="tab"
                                                [attr.data-target]="'#market-content-' + project.ProjectID" type="button" role="tab"
                                                [attr.aria-controls]="'market-content-' + project.ProjectID" aria-selected="false">
                                                <i class="fas fa-chart-line tab-icon" aria-hidden="true"></i>
                                                <span class="tab-label">Market Analytics</span>
                                            </button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" [id]="'location-tab-' + project.ProjectID" data-toggle="tab"
                                                [attr.data-target]="'#location-content-' + project.ProjectID" type="button" role="tab"
                                                [attr.aria-controls]="'location-content-' + project.ProjectID" aria-selected="false">
                                                <i class="fas fa-map-marker-alt tab-icon" aria-hidden="true"></i>
                                                <span class="tab-label">Location & Connectivity</span>
                                            </button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" [id]="'investment-tab-' + project.ProjectID" data-toggle="tab"
                                                [attr.data-target]="'#investment-content-' + project.ProjectID" type="button" role="tab"
                                                [attr.aria-controls]="'investment-content-' + project.ProjectID" aria-selected="false">
                                                <i class="fas fa-coins tab-icon" aria-hidden="true"></i>
                                                <span class="tab-label">Investment & Demographics</span>
                                            </button>
                                        </li>
                                    </ul>

                                    <!-- Tab Content -->
                                    <div class="tab-content analysis-tab-content">

                                        <!-- TAB 1: Nearby Places -->
                                        <div class="tab-pane fade show active" [id]="'nearby-content-' + project.ProjectID" role="tabpanel"
                                            [attr.aria-labelledby]="'nearby-tab-' + project.ProjectID">
                                            <!-- Schools -->
                                            <div *ngIf="getSafeContent(project.ProjectID)?.nearby?.schools?.length > 0">
                                                <h4 class="subsection-title"><i class="fas fa-school section-heading-icon" aria-hidden="true"></i>Schools</h4>
                                                <div class="nearby-grid">
                                                    <div class="nearby-card"
                                                        *ngFor="let school of getSafeContent(project.ProjectID)?.nearby?.schools">
                                                        <h5>{{ school.name || 'N/A' }}</h5>
                                                        <p>{{ school.description || '' }}</p>
                                                        <div class="tag-group">
                                                            <span class="tag">{{ school.tag || 'School' }}</span>
                                                            <span class="distance" *ngIf="school.distance"><i class="fas fa-map-marker-alt inline-info-icon" aria-hidden="true"></i>{{
                                                                school.distance }} km</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Hospitals -->
                                            <div
                                                *ngIf="getSafeContent(project.ProjectID)?.nearby?.hospitals?.length > 0">
                                                <h4 class="subsection-title"><i class="fas fa-hospital section-heading-icon" aria-hidden="true"></i>Hospitals</h4>
                                                <div class="nearby-grid">
                                                    <div class="nearby-card"
                                                        *ngFor="let hospital of getSafeContent(project.ProjectID)?.nearby?.hospitals">
                                                        <h5>{{ hospital.name || 'N/A' }}</h5>
                                                        <p>{{ hospital.description || '' }}</p>
                                                        <div class="tag-group">
                                                            <span class="tag">{{ hospital.tag || 'Healthcare' }}</span>
                                                            <span class="distance" *ngIf="hospital.distance"><i class="fas fa-map-marker-alt inline-info-icon" aria-hidden="true"></i>{{
                                                                hospital.distance }} km</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- IT Companies -->
                                            <div
                                                *ngIf="getSafeContent(project.ProjectID)?.nearby?.itCompanies?.length > 0">
                                                <h4 class="subsection-title"><i class="fas fa-laptop-code section-heading-icon" aria-hidden="true"></i>IT Companies</h4>
                                                <div class="nearby-grid">
                                                    <div class="nearby-card"
                                                        *ngFor="let company of getSafeContent(project.ProjectID)?.nearby?.itCompanies">
                                                        <h5>{{ company.name || 'N/A' }}</h5>
                                                        <p>{{ company.description || '' }}</p>
                                                        <div class="tag-group">
                                                            <span class="tag">{{ company.tag || 'IT Hub' }}</span>
                                                            <span class="distance" *ngIf="company.distance"><i class="fas fa-map-marker-alt inline-info-icon" aria-hidden="true"></i>{{
                                                                company.distance }} km</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Business Hubs -->
                                            <div
                                                *ngIf="getSafeContent(project.ProjectID)?.nearby?.businessHubs?.length > 0">
                                                <h4 class="subsection-title"><i class="fas fa-briefcase section-heading-icon" aria-hidden="true"></i>Business Hubs</h4>
                                                <div class="nearby-grid">
                                                    <div class="nearby-card"
                                                        *ngFor="let hub of getSafeContent(project.ProjectID)?.nearby?.businessHubs">
                                                        <h5>{{ hub.name || 'N/A' }}</h5>
                                                        <p>{{ hub.description || '' }}</p>
                                                        <div class="tag-group">
                                                            <span class="tag">{{ hub.tag || 'Business' }}</span>
                                                            <span class="distance" *ngIf="hub.distance"><i class="fas fa-map-marker-alt inline-info-icon" aria-hidden="true"></i>{{
                                                                hub.distance }} km</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Malls -->
                                            <div *ngIf="getSafeContent(project.ProjectID)?.nearby?.malls?.length > 0">
                                                <h4 class="subsection-title"><i class="fas fa-shopping-bag section-heading-icon" aria-hidden="true"></i>Malls & Shopping</h4>
                                                <div class="nearby-grid">
                                                    <div class="nearby-card"
                                                        *ngFor="let mall of getSafeContent(project.ProjectID)?.nearby?.malls">
                                                        <h5>{{ mall.name || 'N/A' }}</h5>
                                                        <p>{{ mall.description || '' }}</p>
                                                        <div class="tag-group">
                                                            <span class="tag">{{ mall.tag || 'Retail' }}</span>
                                                            <span class="distance" *ngIf="mall.distance"><i class="fas fa-map-marker-alt inline-info-icon" aria-hidden="true"></i>{{
                                                                mall.distance }} km</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Metro Stations -->
                                            <div
                                                *ngIf="getSafeContent(project.ProjectID)?.nearby?.metroStations?.length > 0">
                                                <h4 class="subsection-title"><i class="fas fa-subway section-heading-icon" aria-hidden="true"></i>Metro Stations</h4>
                                                <div class="nearby-grid">
                                                    <div class="nearby-card"
                                                        *ngFor="let metro of getSafeContent(project.ProjectID)?.nearby?.metroStations">
                                                        <h5>{{ metro.name || 'N/A' }}</h5>
                                                        <p>{{ metro.description || '' }}</p>
                                                        <div class="tag-group">
                                                            <span class="tag">{{ metro.tag || 'Metro' }}</span>
                                                            <span class="distance" *ngIf="metro.distance"><i class="fas fa-map-marker-alt inline-info-icon" aria-hidden="true"></i>{{
                                                                metro.distance }} km</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- TAB 2: Market Analytics -->
                                        <div class="tab-pane fade" [id]="'market-content-' + project.ProjectID" role="tabpanel"
                                            [attr.aria-labelledby]="'market-tab-' + project.ProjectID">
                                            <!-- Real Estate Analytics -->
                                            <div *ngIf="getSafeContent(project.ProjectID)?.analytics?.length > 0">
                                                <h4 class="subsection-title"><i class="fas fa-chart-area section-heading-icon" aria-hidden="true"></i>Real Estate Analytics - {{
                                                    project.AreaName }}</h4>
                                                <div class="analytics-grid">
                                                    <div class="analytics-card"
                                                        *ngFor="let analytic of getSafeContent(project.ProjectID)?.analytics">
                                                        <h5>{{ analytic.title || 'Analysis' }}</h5>
                                                        <p *ngFor="let detail of analytic.details">{{ detail }}</p>
                                                        <span class="tag">{{ analytic.tag || 'Info' }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Development Metrics -->
                                            <div
                                                *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.developmentMetrics">
                                                <h4 class="subsection-title"><i class="fas fa-city section-heading-icon" aria-hidden="true"></i>Development Metrics</h4>
                                                <div class="metrics-grid">
                                                    <div class="metric-card"
                                                        *ngFor="let metric of getSafeContent(project.ProjectID)?.locationInsights?.developmentMetrics | keyvalue">
                                                        <strong>{{ metric.key | titlecase }}:</strong> {{ metric.value
                                                        }}
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Area Rating -->
                                            <div
                                                *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.areaRating">
                                                <h4 class="subsection-title"><i class="fas fa-star section-heading-icon" aria-hidden="true"></i>Area Rating</h4>
                                                <div class="rating-grid">
                                                    <div class="rating-item"
                                                        *ngFor="let rating of getSafeContent(project.ProjectID)?.locationInsights?.areaRating | keyvalue">
                                                        <span class="rating-label">{{ rating.key | titlecase }}:</span>
                                                        <div class="rating-stars">
                                                            <ng-container *ngIf="rating.value && rating.value > 0">
                                                                <span
                                                                    *ngFor="let star of getStarArray(rating.value)">⭐</span>
                                                                <span class="rating-value">{{ rating.value }}/5</span>
                                                            </ng-container>
                                                            <ng-container *ngIf="!rating.value || rating.value === 0">
                                                                <span class="rating-value">Not Rated</span>
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Accessibility Score -->
                                            <div
                                                *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore">
                                                <h4 class="subsection-title"><i class="fas fa-route section-heading-icon" aria-hidden="true"></i>Accessibility Score</h4>
                                                <div class="accessibility-grid">
                                                    <div class="accessibility-item">
                                                        <span class="score-value">{{
                                                            getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.score
                                                            || 0 }}/10</span>
                                                        <span class="score-label">Overall Score</span>
                                                    </div>
                                                    <div class="accessibility-details">
                                                        <div
                                                            *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.airport">
                                                            <i class="fas fa-plane-departure inline-info-icon" aria-hidden="true"></i>Airport: {{
                                                            getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.airport
                                                            }}</div>
                                                        <div
                                                            *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.metro">
                                                            <i class="fas fa-subway inline-info-icon" aria-hidden="true"></i>Metro: {{
                                                            getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.metro
                                                            }}</div>
                                                        <div
                                                            *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.highway">
                                                            <i class="fas fa-road inline-info-icon" aria-hidden="true"></i>Highway: {{
                                                            getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.highway
                                                            }}</div>
                                                        <div
                                                            *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.busConnectivity">
                                                            <i class="fas fa-bus inline-info-icon" aria-hidden="true"></i>Bus: {{
                                                            getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.busConnectivity
                                                            }}</div>
                                                        <div
                                                            *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.railwayStation">
                                                            <i class="fas fa-train inline-info-icon" aria-hidden="true"></i>Railway: {{
                                                            getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.railwayStation
                                                            }}</div>
                                                        <div
                                                            *ngIf="getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.itHub">
                                                            <i class="fas fa-laptop-code inline-info-icon" aria-hidden="true"></i>IT Hub: {{
                                                            getSafeContent(project.ProjectID)?.locationInsights?.accessibilityScore?.itHub
                                                            }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- TAB 3: Location & Connectivity -->
                                        <div class="tab-pane fade" [id]="'location-content-' + project.ProjectID" role="tabpanel"
                                            [attr.aria-labelledby]="'location-tab-' + project.ProjectID">
                                            <div *ngIf="getSafeContent(project.ProjectID)?.locationConnectivity">
                                                <div class="location-connectivity-single-row">
                                                    <!-- Road Connectivity -->
                                                    <div class="location-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.locationConnectivity?.roadConnectivity?.length > 0">
                                                        <h4><i class="fas fa-road section-heading-icon" aria-hidden="true"></i>Road Connectivity</h4>
                                                        <ul class="connectivity-list">
                                                            <li
                                                                *ngFor="let road of getSafeContent(project.ProjectID)?.locationConnectivity?.roadConnectivity">
                                                                <span class="bullet"><i class="fas fa-circle"></i></span> {{ road }}
                                                            </li>
                                                        </ul>
                                                        <span class="tag">Easy Access</span>
                                                    </div>

                                                    <!-- Key Distances -->
                                                    <div class="location-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.locationConnectivity?.keyDistances?.length > 0">
                                                        <h4><i class="fas fa-ruler-combined section-heading-icon" aria-hidden="true"></i>Key Distances</h4>
                                                        <ul class="connectivity-list">
                                                            <li
                                                                *ngFor="let distance of getSafeContent(project.ProjectID)?.locationConnectivity?.keyDistances">
                                                                <span class="bullet"><i class="fas fa-map-marker-alt"></i></span> {{ distance }}
                                                            </li>
                                                        </ul>
                                                        <span class="tag">Prime Location</span>
                                                    </div>

                                                    <!-- Location Advantage -->
                                                    <div class="location-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.locationConnectivity?.locationAdvantage?.length > 0">
                                                        <h4><i class="fas fa-map-signs section-heading-icon" aria-hidden="true"></i>Location Advantage</h4>
                                                        <ul class="connectivity-list">
                                                            <li
                                                                *ngFor="let advantage of getSafeContent(project.ProjectID)?.locationConnectivity?.locationAdvantage">
                                                                <span class="bullet"><i class="fas fa-check"></i></span> {{ advantage }}
                                                            </li>
                                                        </ul>
                                                        <span class="tag">Hot Location</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- TAB 4: Investment & Demographics -->
                                        <div class="tab-pane fade" [id]="'investment-content-' + project.ProjectID" role="tabpanel"
                                            [attr.aria-labelledby]="'investment-tab-' + project.ProjectID">
                                            <!-- Investment Analysis -->
                                            <div *ngIf="getSafeContent(project.ProjectID)?.investment">
                                                <h4 class="subsection-title"><i class="fas fa-coins section-heading-icon" aria-hidden="true"></i>Investment Analysis</h4>
                                                <div class="investment-grid">
                                                    <div class="investment-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.investment?.presentAvgRate">
                                                        <div class="investment-label">Present Avg Rate</div>
                                                        <div class="investment-value">{{
                                                            getSafeContent(project.ProjectID)?.investment?.presentAvgRate
                                                            }}</div>
                                                    </div>
                                                    <div class="investment-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.investment?.yoYGrowth">
                                                        <div class="investment-label">YoY Growth</div>
                                                        <div class="investment-value">{{
                                                            getSafeContent(project.ProjectID)?.investment?.yoYGrowth }}
                                                        </div>
                                                    </div>
                                                    <div class="investment-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.investment?.demandSupply">
                                                        <div class="investment-label">Demand/Supply</div>
                                                        <div class="investment-value">{{
                                                            getSafeContent(project.ProjectID)?.investment?.demandSupply
                                                            }}</div>
                                                    </div>
                                                    <div class="investment-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.investment?.recommendedHorizon">
                                                        <div class="investment-label">Investment Horizon</div>
                                                        <div class="investment-value">{{
                                                            getSafeContent(project.ProjectID)?.investment?.recommendedHorizon
                                                            }}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Demographics -->
                                            <div *ngIf="getSafeContent(project.ProjectID)?.demographics">
                                                <h4 class="subsection-title"><i class="fas fa-users section-heading-icon" aria-hidden="true"></i>Demographics</h4>
                                                <div class="demographics-grid">
                                                    <div class="demographic-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.demographics?.populationDensity">
                                                        <span class="demo-icon"><i class="fas fa-user-friends" aria-hidden="true"></i></span>
                                                        <div>
                                                            <strong>Population Density</strong>
                                                            <p>{{
                                                                getSafeContent(project.ProjectID)?.demographics?.populationDensity
                                                                }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="demographic-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.demographics?.incomeLevel">
                                                        <span class="demo-icon"><i class="fas fa-wallet" aria-hidden="true"></i></span>
                                                        <div>
                                                            <strong>Income Level</strong>
                                                            <p>{{
                                                                getSafeContent(project.ProjectID)?.demographics?.incomeLevel
                                                                }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="demographic-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.demographics?.ageGroup">
                                                        <span class="demo-icon"><i class="fas fa-birthday-cake" aria-hidden="true"></i></span>
                                                        <div>
                                                            <strong>Age Group</strong>
                                                            <p>{{
                                                                getSafeContent(project.ProjectID)?.demographics?.ageGroup
                                                                }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="demographic-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.demographics?.occupationProfile">
                                                        <span class="demo-icon"><i class="fas fa-briefcase" aria-hidden="true"></i></span>
                                                        <div>
                                                            <strong>Occupation Profile</strong>
                                                            <p>{{
                                                                getSafeContent(project.ProjectID)?.demographics?.occupationProfile
                                                                }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Property Specific Details -->
                                            <div *ngIf="getSafeContent(project.ProjectID)?.propertySpecific">
                                                <h4 class="subsection-title">
                                                    <ng-container *ngIf="project.Property_Type == 1"><i class="fas fa-home section-heading-icon" aria-hidden="true"></i>Property
                                                        Details</ng-container>
                                                    <ng-container *ngIf="project.Property_Type == 2"><i class="fas fa-building section-heading-icon" aria-hidden="true"></i>Commercial
                                                        Details</ng-container>
                                                    <ng-container *ngIf="project.Property_Type == 3"><i class="fas fa-map-marker-alt section-heading-icon" aria-hidden="true"></i>Land
                                                        Details</ng-container>
                                                </h4>
                                                <div class="property-specific-grid">
                                                    <div class="spec-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.propertySpecific?.plotSizes?.length > 0">
                                                        <strong>Plot Sizes</strong>
                                                        <div class="spec-value">{{
                                                            getSafeContent(project.ProjectID)?.propertySpecific?.plotSizes?.join(',
                                                            ') }}</div>
                                                    </div>
                                                    <div class="spec-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.propertySpecific?.bhkConfigurations?.length > 0">
                                                        <strong>BHK Configurations</strong>
                                                        <div class="spec-value">{{
                                                            getSafeContent(project.ProjectID)?.propertySpecific?.bhkConfigurations?.join(',
                                                            ') }}</div>
                                                    </div>
                                                    <div class="spec-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.propertySpecific?.approvalStatus">
                                                        <strong>Approval Status</strong>
                                                        <div class="spec-value">{{
                                                            getSafeContent(project.ProjectID)?.propertySpecific?.approvalStatus
                                                            }}</div>
                                                    </div>
                                                    <div class="spec-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.propertySpecific?.futureDevelopment">
                                                        <strong>Future Development</strong>
                                                        <div class="spec-value">{{
                                                            getSafeContent(project.ProjectID)?.propertySpecific?.futureDevelopment
                                                            }}</div>
                                                    </div>
                                                    <div class="spec-card"
                                                        *ngIf="getSafeContent(project.ProjectID)?.propertySpecific?.rentalYield">
                                                        <strong>Rental Yield</strong>
                                                        <div class="spec-value">{{
                                                            getSafeContent(project.ProjectID)?.propertySpecific?.rentalYield
                                                            }}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Disclaimer -->
                                            <div *ngIf="getSafeContent(project.ProjectID)?.priceDisclaimer"
                                                class="disclaimer-box">
                                                <i class="fas fa-info-circle"></i> {{
                                                getSafeContent(project.ProjectID)?.priceDisclaimer }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Powered by Section -->
                            </article>

                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>

    <div class="venture-list-add" *ngIf="!isVentureView">
        <div> <button id="help_bt" class="btn btn-info"
                onclick="document.getElementById('help_div').style.display='block';return false;">
                <i class="fa fa-question-circle"></i> Help
            </button></div>
        <div class="pad10T">
            <div class="Property_Title"> Your Project or Venture</div>
            <div class="pad5T"> Showcase every detail that matters to build trust, attract interest, and empower buyers
                with all the information they need.</div>
        </div>

        <div class="modal-content" style="background-color: transparent;">
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-9 box_div">
                        <form autocomplete="off" [formGroup]="ventureForm" method="post"
                            (ngSubmit)="doSaveVentureDetails()">

                            <div class="row">
                                <div class="pad10A pad15L"> <label class="form-check-label"
                                        style="color: #000;font-weight: 500;">Property Type</label></div>
                                <div class="category-type-div">
                                    <ul>
                                        <li>
                                            <input class="rdbcategory-type" type="radio" name="select"
                                                id="rdbProperty-type-1"
                                                [checked]="ventureForm.controls['Property_Type'].value  == 1 ? true : false"
                                                (change)="LoadSubPropertyByID(1)" />
                                            <label for="option-1" class="option option-1"
                                                (click)="LoadSubPropertyByID(1)">
                                                <span>Residential</span>
                                            </label>
                                        </li>
                                        <li>
                                            <input class="rdbcategory-type" type="radio" name="select"
                                                id="rdbProperty-type-2"
                                                [checked]="ventureForm.controls['Property_Type'].value  == 2 ? true : false"
                                                (change)="LoadSubPropertyByID(2)" />
                                            <label for="option-2" class="option option-2"
                                                (click)="LoadSubPropertyByID(2)">
                                                <span>Commercial</span>
                                            </label>
                                        </li>

                                        <li>
                                            <input class="rdbcategory-type" type="radio" name="select"
                                                id="rdbProperty-type-3"
                                                [checked]="ventureForm.controls['Property_Type'].value  == 3 ? true : false"
                                                (change)="LoadSubPropertyByID(3)" />
                                            <label for="option-3" class="option option-3"
                                                (click)="LoadSubPropertyByID(3)">
                                                <span>Land</span>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="elevate_cls area_units">
                                <div class="row mrg15T">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="txtVentureName" class="form-label">Project / Venture
                                                Name</label>
                                            <input type="text" class="form-control" id="txtVentureName"
                                                formControlName="ProjectOrVentureName" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="txtDeveloperName" class="form-label">Developer Name</label>
                                            <input type="text" class="form-control" id="txtDeveloperName"
                                                formControlName="Developer_Name" />
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="txtProjectOrVentureID" class="form-label">Venture Code</label>
                                            <input type="text" class="form-control" id="txtProjectOrVentureID"
                                                formControlName="ProjectOrVentureID" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="ddlProjectStatus" class="form-label">Project Status</label>
                                            <select class="form-control" id="ddlProjectStatus"
                                                formControlName="ProjectStatus">
                                                <option value="">Select</option>
                                                <option *ngFor="let status of ProjectStatusList"
                                                    value="{{ status.value }}">{{
                                                    status.text }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="txtAreaID" class="form-label">Select Area <span
                                                    class="text-danger">*</span></label>

                                            <!-- Searchable Dropdown -->
                                            <div class="dropdown" [class.show]="isAreaDropdownOpen">
                                                <div class="input-group">
                                                    <input type="text" id="areaSearchInput" class="form-control"
                                                        placeholder="Search area..." [(ngModel)]="areaSearch"
                                                        (click)="toggleAreaDropdown($event)"
                                                        (input)="onAreaSearchChange()"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <div class="input-group-append whitebg">
                                                        <button
                                                            class="btn btn-outline-secondary area_dropbg dropdown-toggle"
                                                            type="button" (click)="toggleAreaDropdown($event)">
                                                        </button>
                                                    </div>
                                                </div>

                                                <!-- Dropdown Menu -->
                                                <div class="dropdown-menu w-100" id="areaDropdownMenu"
                                                    [class.show]="isAreaDropdownOpen"
                                                    style="max-height: 300px; overflow-y: auto;">

                                                    <!-- Search input inside dropdown (optional, for better UX) -->
                                                    <div class="px-3 py-2" style="border-bottom: 1px solid #ddd;">
                                                        <input type="text"
                                                            class="form-control search_br form-control-sm"
                                                            placeholder="Search areas..." [(ngModel)]="areaSearch"
                                                            (input)="onAreaSearchChange()"
                                                            (click)="$event.stopPropagation()"
                                                            [ngModelOptions]="{standalone: true}">
                                                    </div>

                                                    <!-- Areas List -->
                                                    <div *ngIf="filteredAreas.length > 0">
                                                        <div *ngFor="let area of filteredAreas" class="dropdown-item"
                                                            (click)="selectArea(area)" style="cursor: pointer;">
                                                            {{ area.AreaName }}
                                                        </div>
                                                    </div>

                                                    <!-- No Results -->
                                                    <div *ngIf="filteredAreas.length === 0"
                                                        class="dropdown-item text-muted" style="cursor: default;">
                                                        No matching area found.
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Hidden form control for reactive form -->
                                            <select formControlName="AreaID" style="display: none;">
                                                <option [value]="selectedAreaId"></option>
                                            </select>

                                            <!-- Validation Error -->
                                            <div *ngIf="ventureForm.get('AreaID')?.invalid && ventureForm.get('AreaID')?.touched"
                                                class="text-danger small mt-1">
                                                Area is required
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row"
                                    [ngClass]="{'d-none': ventureForm.controls['Property_Type'].value === 3}">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="txtNumberOfUnitsOrPlots" class="form-label">Total Units</label>
                                            <input type="text" class="form-control" id="txtNumberOfUnitsOrPlots"
                                                formControlName="NumberOfUnitsOrPlots" />
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="txtBlocks" class="form-label">Blocks</label>
                                            <input type="text" class="form-control" id="txtBlocks"
                                                formControlName="Blocks" />
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="txtNumberOfFloors" class="form-label">Floors</label>
                                            <input type="text" class="form-control" id="txtNumberOfFloors"
                                                formControlName="NumberOfFloors" />
                                        </div>
                                    </div>

                                </div>

                                <!-- For Land - show Plot/Land specific label -->
                                <div class="row" *ngIf="ventureForm.controls['Property_Type'].value === 3">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="txtNumberOfUnitsOrPlots" class="form-label">Total Plots / Land
                                                Parcels</label>
                                            <input type="text" class="form-control" id="txtNumberOfUnitsOrPlots"
                                                formControlName="NumberOfUnitsOrPlots"
                                                placeholder="Number of plots available" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="txtVentureName" class="form-label">Total Project Area</label>
                                            <select class="form-control" id="ddlTotalArea" formControlName="UnitId">
                                                <option value="">Select</option>
                                                <option *ngFor="let mesr of MeasureList" [value]="mesr.UnitID">{{
                                                    mesr.UnitName
                                                    }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="txtMeasure" class="form-label">Measure</label>
                                            <input type="text" class="form-control" id="txtMeasure"
                                                formControlName="UnitMeasures" />
                                        </div>
                                    </div>
                                </div>
                                <!-- Update Open Space label -->
                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="txtOpen_Space" class="form-label">
                                                <ng-container
                                                    *ngIf="ventureForm.controls['Property_Type'].value !== 3">Open
                                                    Space(%)</ng-container>
                                                <ng-container
                                                    *ngIf="ventureForm.controls['Property_Type'].value === 3">Open Land
                                                    Area(%)</ng-container>
                                            </label>
                                            <input type="text" class="form-control" id="txtOpen_Space"
                                                formControlName="Open_Space" />
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="txtPricingDetails" class="form-label">
                                                <ng-container
                                                    *ngIf="ventureForm.controls['Property_Type'].value !== 3">Price
                                                    (Min-Max)</ng-container>
                                                <ng-container
                                                    *ngIf="ventureForm.controls['Property_Type'].value === 3">Price per
                                                    sq.yard / acre</ng-container>
                                            </label>
                                            <input type="text" class="form-control" id="txtPricingDetails"
                                                formControlName="PricingDetails"
                                                [placeholder]="ventureForm.controls['Property_Type'].value === 3 ? 'Ex: 50000 per sq.yard' : 'Ex: 50000-250000'" />
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="txtLaunchDate" class="form-label">Launch Date</label>
                                            <input type="text" class="form-control date_input" id="txtLaunchDate"
                                                data-provide="datepicker" formControlName="LaunchDate"
                                                (blur)="UpdateDate($event, 'LD')" />
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label for="txtCompletionDate" class="form-label">Completion Date</label>
                                            <input type="text" class="form-control date_input" id="txtCompletionDate"
                                                formControlName="CompletionDate" (blur)="UpdateDate($event, 'CD')" />
                                        </div>
                                    </div>
                                </div>

                                <!-- Update Type of Units field to show appropriate label -->
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="txtTypesOfUnits" class="form-label">
                                                <ng-container
                                                    *ngIf="ventureForm.controls['Property_Type'].value === 1">Type of
                                                    Units</ng-container>
                                                <ng-container
                                                    *ngIf="ventureForm.controls['Property_Type'].value === 2">Type of
                                                    Commercial Spaces</ng-container>
                                                <ng-container
                                                    *ngIf="ventureForm.controls['Property_Type'].value === 3">Plot Sizes
                                                    Available</ng-container>
                                            </label>
                                            <input type="text" class="form-control"
                                                [placeholder]="ventureForm.controls['Property_Type'].value === 1 ? 'Ex: 2BHK, 3BHK, VILLAS' : (ventureForm.controls['Property_Type'].value === 2 ? 'Ex: Office, Retail, Showroom' : 'Ex: 200 sq.yards, 400 sq.yards')"
                                                id="txtTypesOfUnits" formControlName="TypesOfUnits" />
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="txtLegalApprovals" class="form-label">Legal Approvals</label>
                                            <input type="text" class="form-control" id="txtLegalApprovals"
                                                formControlName="LegalApprovals" placeholder="RERA No, HMDA No" />
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="txtAmenities" class="form-label">Amenities</label>
                                            <div class="dropdown">
                                                <button
                                                    class="btn btn-outline-secondary dropdown-toggle form-control text-left"
                                                    type="button" id="amenitiesDropdown"
                                                    (click)="toggleDropdown($event)" aria-haspopup="true"
                                                    [attr.aria-expanded]="isDropdownOpen">
                                                    <span
                                                        *ngIf="(ventureForm.controls['Amenities'].value || []).length === 0">Select
                                                        Amenities</span>
                                                    <span
                                                        *ngIf="(ventureForm.controls['Amenities'].value || []).length > 0">{{
                                                        (ventureForm.controls['Amenities'].value || []).length }}
                                                        selected</span>
                                                </button>
                                                <div class="dropdown-menu w-100" id="amenitiesDropdownMenu"
                                                    [class.show]="isDropdownOpen" aria-labelledby="amenitiesDropdown"
                                                    style="max-height: 200px; overflow-y: auto;"
                                                    (click)="$event.stopPropagation()">
                                                    <div *ngFor="let amenitie of amenitiesList" class="dropdown-item">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox"
                                                                [id]="'amenity_' + amenitie.AmenityID"
                                                                [value]="amenitie.AmenityID"
                                                                (change)="onAmenityChange($event, amenitie.AmenityID)"
                                                                [checked]="isAmenitySelected(amenitie.AmenityID)">
                                                            <label class="form-check-label"
                                                                [for]="'amenity_' + amenitie.AmenityID">
                                                                {{ amenitie.AmenityName }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="budget-div mrg10T">
                                <div class="elevate_cls">
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <label for="rdbReqWant"
                                                    style="float: left; margin-right: 5px; margin-top: 5px; color: #000;font-weight: 500;">Location:</label>
                                                <div class="category-radio-div">
                                                    <!-- Current Location Option -->
                                                    <div class="form-check form-check-inline l-radio">
                                                        <div class="panel-container"
                                                            (click)="selectRadio('rdbSameLocation')">
                                                            <input class="form-check-input" type="radio"
                                                                name="rdbPropLocation" id="rdbSameLocation" value="Same"
                                                                (change)="doChangeLocation(1)" />
                                                            <label class="form-check-label" for="rdbSameLocation"
                                                                style="color: #000;font-weight: 500;">
                                                                <i class="fas fa-location-dot text-success"></i> Current
                                                                Location
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <!-- Other Location Option -->
                                                    <div class="form-check form-check-inline l-radio">
                                                        <div class="panel-container"
                                                            (click)="selectRadio('rdbOtherLocation')">
                                                            <input class="form-check-input" type="radio"
                                                                name="rdbPropLocation" id="rdbOtherLocation"
                                                                value="Other" (change)="doChangeLocation(0)" />
                                                            <label class="form-check-label" for="rdbOtherLocation"
                                                                style="color: #000;font-weight: 500;">
                                                                <i class="fas fa-map-marker-alt text-warning"></i> Other
                                                                Location
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <!-- NEW: Search Location Option -->
                                                    <div class="form-check form-check-inline l-radio">
                                                        <div class="panel-container"
                                                            (click)="selectRadio('rdbSearchLocation')">
                                                            <input class="form-check-input" type="radio"
                                                                name="rdbPropLocation" id="rdbSearchLocation"
                                                                value="Search" (change)="doChangeLocation(2)" />
                                                            <label class="form-check-label" for="rdbSearchLocation"
                                                                style="color: #000;font-weight: 500;">
                                                                <i class="fas fa-search text-info"></i> Search Location
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="pad10T">
                                            <!-- Address Textarea (for Current and Other Location) -->
                                            <textarea *ngIf="locationMode !== 'search'" class="form-control"
                                                id="txtDescription" [(ngModel)]="ventureLocation.address"
                                                (blur)="loadMapBasedOnAddress()" [ngModelOptions]="{standalone: true}"
                                                style="margin-bottom: 10px;"
                                                [attr.readonly]="locationMode === 'current' ? 'readonly' : null"
                                                required></textarea>

                                            <!-- Search Location Input Group -->
                                            <div *ngIf="locationMode === 'search'" class="search-location-container">
                                                <div class="input-group mb-2">
                                                    <input type="text" class="form-control" id="searchLocationInput"
                                                        placeholder="Search for address, landmark, or place..."
                                                        [(ngModel)]="searchAddress"
                                                        [ngModelOptions]="{standalone: true}"
                                                        (keyup.enter)="searchLocation()">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-primary" type="button"
                                                            (click)="searchLocation()">
                                                            <i class="fas fa-search"></i> Search
                                                        </button>
                                                    </div>
                                                </div>

                                                <!-- Search Results Dropdown -->
                                                <div *ngIf="searchResults.length > 0" class="search-results-list">
                                                    <div *ngFor="let result of searchResults" class="search-result-item"
                                                        (click)="selectSearchResult(result)">
                                                        <div class="result-title">{{ result.formatted_address }}</div>
                                                        <div class="result-detail" *ngIf="result.vicinity">{{
                                                            result.vicinity }}</div>
                                                    </div>
                                                </div>

                                                <!-- Selected Address Display -->
                                                <div *ngIf="ventureLocation.address && ventureLocation.address !== ''"
                                                    class="selected-address mt-2">
                                                    <div class="alert alert-success">
                                                        <strong><i class="fas fa-check-circle"></i> Selected
                                                            Location:</strong>
                                                        <p class="mb-0 mt-1">{{ ventureLocation.address }}</p>
                                                        <small class="text-muted">
                                                            Lat: {{ ventureLocation.lattitude }}, Lng: {{
                                                            ventureLocation.longitude }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Map Container -->
                                            <div id="venturePostMap" [ngClass]="{'hidden': !showMap}"
                                                style="width: 100%; margin-bottom: 20px; height: 200px;">
                                            </div>

                                            <!-- Instructional Text -->
                                            <p *ngIf="showMap && locationMode !== 'search'"
                                                style="font-size: small; color: black;">
                                                <i class="fas fa-map-marker-alt text-danger"></i> Drag Location Icon to
                                                your desired place
                                            </p>
                                            <p *ngIf="showMap && locationMode === 'search'"
                                                style="font-size: small; color: black;">
                                                <i class="fas fa-map-marker-alt text-danger"></i> Pin shows exact
                                                location from your search
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group elevate_cls">
                                        <label for="lblOverview" class="form-label">Overview</label>
                                        <angular-editor class="form-control" id="txtOverview"
                                            [placeholder]="'Enter text here...'" maxlength="4000"
                                            formControlName="Overview"></angular-editor>
                                    </div>
                                </div>
                            </div>

                            <!-- Add this after the Overview section and before the Resource Upload section -->

                            <!-- Social Media Links Section -->
                            <div class="row mrg15T">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4 class="venture-upload-title">Social Media & Online Presence</h4>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="txtYouTubeUrl" class="form-label">
                                                            <i class="fab fa-youtube text-danger"></i> YouTube URL /
                                                            Channel
                                                        </label>
                                                        <input type="url" class="form-control" id="txtYouTubeUrl"
                                                            formControlName="YouTubeUrl"
                                                            placeholder="YouTube: @channel, video ID, or full URL" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="txtFacebookUrl" class="form-label">
                                                            <i class="fab fa-facebook text-primary"></i> Facebook URL /
                                                            ID
                                                        </label>
                                                        <input type="url" class="form-control" id="txtFacebookUrl"
                                                            formControlName="FacebookUrl"
                                                            placeholder="https://facebook.com/..." />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="txtInstagramUrl" class="form-label">
                                                            <i class="fab fa-instagram text-danger"></i> Instagram URL
                                                        </label>
                                                        <input type="url" class="form-control" id="txtInstagramUrl"
                                                            formControlName="InstagramUrl"
                                                            placeholder="https://instagram.com/..." />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="txtWhatsapp" class="form-label">
                                                            <i class="fab fa-whatsapp text-success"></i> WhatsApp
                                                            Number/Business Link
                                                        </label>
                                                        <input type="text" class="form-control" id="txtWhatsapp"
                                                            formControlName="Whatsapp"
                                                            placeholder="WhatsApp: 10-digit number or full URL" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" *ngIf="ventureForm.controls['Property_Type'].value === 2">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="txtTelegram" class="form-label">
                                                            <i class="fab fa-telegram text-primary"></i> Telegram
                                                            Channel
                                                        </label>
                                                        <input type="text" class="form-control" id="txtTelegram"
                                                            formControlName="Telegram"
                                                            placeholder="Telegram channel link" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4 class="venture-upload-title">Upload Venture Resource Files(Images,
                                                Venture Plan and Resource...etc)</h4>
                                        </div>

                                        <div class="card-body">
                                            <!-- Update the Resource Type dropdown options -->
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="ddlResourceType" class="form-label">Resource
                                                            Type</label>
                                                        <select class="form-control" id="ddlResourceType"
                                                            [(ngModel)]="uploadFileType"
                                                            [ngModelOptions]="{standalone: true}"
                                                            (change)="onResourceTypeChange($event)">
                                                            <option value="">Select</option>
                                                            <option *ngFor="let type of resourceTypes"
                                                                [value]="type.value">{{ type.text }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label for="txtResourceTitle" class="form-label">Resource
                                                            Title</label>
                                                        <input type="text" class="form-control" id="txtResourceTitle"
                                                            [(ngModel)]="uploadFileTitle"
                                                            [ngModelOptions]="{standalone: true}" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div align="center"
                                                        class="upload-doc-view-div upload-section d-flex flex-wrap gap-2 justify-content-center"
                                                        (drop)="handleDropResource($event)"
                                                        (dragover)="allowDrop($event)">

                                                        <!-- Preview of Uploaded Resources -->
                                                        <div class="post-inner-pic-div"
                                                            *ngFor="let path of Resources; let i = index">
                                                            <!-- Image Preview -->
                                                            <img *ngIf="isImage(path.FileName)" [src]="path.FileName"
                                                                alt="Image" />

                                                            <!-- Video Preview -->
                                                            <img *ngIf="isVideo(path.FileName)"
                                                                src="assets/images/video_ic.png" alt="Video"
                                                                style="cursor: pointer;"
                                                                (click)="viewUploadedVideo(path.FileName)" />

                                                            <!-- PDF Preview -->
                                                            <div class="docView" *ngIf="isPDF(path.FileName)">
                                                                <embed [src]="getSafeUrl(path.FileName)"
                                                                    type="application/pdf" width="100px" height="120px"
                                                                    style="border: 1px solid #ccc; border-radius: 4px;" />
                                                            </div>

                                                            <!-- Remove Button -->
                                                            <div class="remove-pic-div"
                                                                (click)="removeUploadedImg(i, 'I')">
                                                                <i class="fas fa-trash"></i>
                                                            </div>

                                                            <span class="image-lable">{{ path?.ContentType }}</span>
                                                        </div>




                                                        <!-- Upload Button / Drop Target -->
                                                        <div class="post-upload-pic-div upload-drop-area"
                                                            (click)="doUploadImage()">
                                                            <i class="drop_img"></i>
                                                            <div class="drop_txt">Drop or <span
                                                                    class="drop_txt_hi_txt">browse</span></div>
                                                            <div class="support_txt">Supports: JPG, JPEG2000, PNG, GIF,
                                                                WEBP, MP4, PDF</div>
                                                            <input type="file" class="form-control" id="propertyFiles"
                                                                name="propertyFiles" style="display: none;"
                                                                [attr.accept]="uploadFileAcceptTypes"
                                                                (change)="VentureFiles_change($event)" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="row mrg20T">
                                <div class="col-md-6 mrg10B">
                                    <button type="button" class="secondarybt" (click)="HideVentureAdd()">Close</button>
                                </div>
                                <div class="col-md-6 mrg10B"> <button type="submit" class="primarybt">Submit</button>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="col-md-3" id="help_div">
                        <div class="side_bg"></div>
                        <div class="side_property">
                            <div onclick="document.getElementById('help_div').style.display='none';return false;"
                                class="cross_ic right"></div>
                            <div>
                                <div class="hd_txt">Video Help</div>
                                <img src="assets/images/video_ic.png" class="w100p">
                            </div>
                            <div class="clearfix mrg15B"></div>
                            <div>
                                <div class="hd_txt">Speak to our Agent</div>
                                <div class="box_div">
                                    <table width="100%" border="0" cellspacing="2" cellpadding="0">
                                        <tr>
                                            <td align="center" valign="top" class="pad5T"><img _ngcontent-fbg-c115=""
                                                    class="rounded-circle" alt=""
                                                    src="assets/images/customer_images.jpg"
                                                    style="width:auto; height:100px;"></td>
                                        </tr>
                                        <tr>
                                            <td align="center" valign="top" class="pad5T">
                                                <table border="0" cellspacing="2" cellpadding="0">
                                                    <tr>
                                                        <td align="center"><strong> Srinivas Reddy R</strong></td>
                                                    </tr>
                                                    <tr>
                                                        <td align="center" class="gray_txt">Executive Manager </td>
                                                    </tr>
                                                    <tr>
                                                        <td align="center"><img
                                                                src="assets/images/agent/phone_no_icon.png" alt="Phone"
                                                                height="15px"> 9032200318</td>
                                                    </tr>
                                                    <tr>
                                                        <td align="center"><img src="assets/images/agent/Mail_icon.png"
                                                                alt="E-mail" width="15px">
                                                            srilekhareddy.2001&#64;gmail.com
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
                            <div class="clearfix mrg15B"></div>
                            <div class="pad15T">
                                <div class="hd_txt pad5B">Help guide</div>
                                <div class="help_bg">
                                    <div class="accordion" id="accordionExample">
                                        <div class="card">
                                            <div class="card-header" id="headingOne">
                                                <h2 class="mb-0">
                                                    <button class="btn btn-link btn-block text-left" type="button"
                                                        data-toggle="collapse" data-target="#collapseOne"
                                                        aria-expanded="true" aria-controls="collapseOne">
                                                        How can I upload my Project or Venture?
                                                    </button>
                                                </h2>
                                            </div>

                                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    <p>To upload your project:</p>
                                                    <ul type="disc">
                                                        <li>Go to the <strong>&quot;Upload Venture&quot;</strong>
                                                            section in
                                                            your dashboard.</li>
                                                        <li>Fill in key details like <strong>Project Name, Developer
                                                                Name,
                                                                Venture Code, Project Status, Area, Unit Types, Legal
                                                                Approvals, etc.</strong></li>
                                                        <li>Drag the <strong>Google Map Marker</strong> to mark the
                                                            exact
                                                            location of your venture.</li>
                                                        <li>Add a brief <strong>overview</strong> to describe your
                                                            venture.
                                                        </li>
                                                        <li>Upload <strong>images, videos, brochures</strong>, and other
                                                            resources under the &ldquo;Upload Venture Resources&rdquo;
                                                            section.</li>
                                                        <li>Click <strong>Submit</strong> to finish.</li>
                                                    </ul>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h2 class="mb-0">
                                                    <button class="btn btn-link btn-block text-left collapsed"
                                                        type="button" data-toggle="collapse" data-target="#collapseTwo"
                                                        aria-expanded="false" aria-controls="collapseTwo">
                                                        How many images and videos can I upload per venture?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    <p>You can upload:</p>
                                                    <ul type="disc">
                                                        <li>Up to <strong>20 images</strong> per project (JPEG, PNG).
                                                        </li>
                                                        <li>Up to <strong>5 videos</strong> (MP4 or YouTube links).</li>
                                                        <li>Ensure each file is under <strong>15 MB</strong> for optimal
                                                            upload speed and quality.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingThree">
                                                <h2 class="mb-0">
                                                    <button class="btn btn-link btn-block text-left collapsed"
                                                        type="button" data-toggle="collapse"
                                                        data-target="#collapseThree" aria-expanded="false"
                                                        aria-controls="collapseThree">
                                                        What types of resources can I upload with my project?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    <p>You can upload the following resources:</p>
                                                    <ul type="disc">
                                                        <li><strong>Logo</strong> of the venture or company</li>
                                                        <li><strong>Brochures</strong> (Image/PDF format)</li>
                                                        <li><strong>Project or Venture Images</strong> (interiors,
                                                            amenities, site photos)</li>
                                                        <li><strong>Videos</strong> (walkthroughs, drone views)</li>
                                                        <li><strong>Layout/Unit Plans</strong> (Venture map, 2BHK/3BHK
                                                            floor
                                                            plans)</li>
                                                        <li><strong>Legal Approvals or Certificates</strong> (RERA,
                                                            HMDA,
                                                            etc.)</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card">
                                            <div class="card-header" id="headingFour">
                                                <h2 class="mb-0">
                                                    <button class="btn btn-link btn-block text-left collapsed"
                                                        type="button" data-toggle="collapse" data-target="#collapseFour"
                                                        aria-expanded="false" aria-controls="collapseFour">
                                                        What types of resources can I upload with my project?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    <p>You can upload the following resources:</p>
                                                    <ul type="disc">
                                                        <li><strong>Logo</strong> of the venture or company</li>
                                                        <li><strong>Brochures</strong> (Image/PDF format)</li>
                                                        <li><strong>Project or Venture Images</strong> (interiors,
                                                            amenities, site photos)</li>
                                                        <li><strong>Videos</strong> (walkthroughs, drone views)</li>
                                                        <li><strong>Layout/Unit Plans</strong> (Venture map, 2BHK/3BHK
                                                            floor
                                                            plans)</li>
                                                        <li><strong>Legal Approvals or Certificates</strong> (RERA,
                                                            HMDA,
                                                            etc.)</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="card">
                                            <div class="card-header" id="headingFive">
                                                <h2 class="mb-0">
                                                    <button class="btn btn-link btn-block text-left collapsed"
                                                        type="button" data-toggle="collapse" data-target="#collapseFive"
                                                        aria-expanded="false" aria-controls="collapseFive">
                                                        Can I update or edit my venture details later?
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id="collapseFive" class="collapse" aria-labelledby="headingFive"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    <p>Yes, you can:</p>
                                                    <ul type="disc">
                                                        <li>Log in to your account.</li>
                                                        <li>Go to the <strong>&quot;My Ventures&quot;</strong> section.
                                                        </li>
                                                        <li>Click <strong>Edit</strong> on your submitted venture.</li>
                                                        <li>Update any detail or replace images/documents anytime.</li>
                                                        <li>After editing, changes will go through <strong>quick
                                                                moderation</strong> and be live shortly.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </div>
        </div>

    </div>
</div>


<div class="modal fade" id="ImageViewModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    data-backdrop="static" data-keyboard="false" aria-hidden="true">
    <div class="modal-dialog" role="document" style="height: 80%;">
        <div class="modal-content" style="height: auto; overflow: hidden;">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Venture Resources</h5>
                <button type="button" (click)="ResetImageView()" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="height: calc(100% - 50px);">
                <!-- Adjusted height to make room for the footer -->
                <app-image-view *ngIf="ltImage.length != 0" [ImageList]="ltImage"></app-image-view>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="ResetImageView()"
                    data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="viewVideoModal" tabindex="-1" role="dialog" aria-labelledby="VentureAddLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="VentureAddLabel">Play Uploaded Vide</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" *ngIf="videoPath != ''">
                <video class="thumbnail custom-video" controls [src]="videoPath"></video>
            </div>
        </div>
    </div>
</div>

<!-- Full Map Modal -->
<div class="modal fade" id="fullMapModal" tabindex="-1" role="dialog" aria-labelledby="fullMapModalLabel"
    data-backdrop="static" data-keyboard="false" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document" style="max-width: 90%; width: 90%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="fullMapModalLabel">
                    <i class="fas fa-map-marker-alt text-danger"></i>
                    {{ selectedVentureForMap?.ProjectOrVentureName }} - Location Map
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="padding: 0; height: 70vh;">
                <div id="fullMapModalMap" style="width: 100%; height: 100%;"></div>
            </div>
            <div class="modal-footer">
                <div class="mr-auto">
                    <small class="text-muted">
                        <i class="fas fa-info-circle"></i>
                        Drag the map • Double click to zoom • Use scroll to zoom in/out
                    </small>
                </div>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    <i class="fas fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-primary" (click)="openInGoogleMaps()">
                    <i class="fas fa-external-link-alt"></i> Open in Google Maps
                </button>
            </div>
        </div>
    </div>
</div>